import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.267 10.112c.227.252.922.379 1.416-.131.494-.51 0-1.285 0-1.285A6.988 6.988 0 0 0 35.15 6.48 129.322 129.322 0 0 0 24 6c-3.745 0-7.462.16-11.15.479a7 7 0 0 0-6.37 6.37A129.13 129.13 0 0 0 6 24c0 3.74.16 7.458.48 11.151a7 7 0 0 0 6.37 6.371c3.683.319 7.4.478 11.15.478s7.467-.16 11.15-.478a7 7 0 0 0 6.37-6.37 129.331 129.331 0 0 0 .412-15.376l-.002-.06c-.005-.32-.015-.93-.941-.93-.989 0-1.059.977-1.059.977a128.456 128.456 0 0 1-.402 15.216 5 5 0 0 1-4.55 4.55C31.352 39.843 27.693 40 24 40c-3.693 0-7.352-.157-10.978-.47a5 5 0 0 1-4.55-4.551A127.333 127.333 0 0 1 8 24c0-3.683.157-7.343.472-10.978a5 5 0 0 1 4.55-4.55C16.652 8.156 20.312 8 24 8c3.688 0 7.347.157 10.978.471a4.992 4.992 0 0 1 3.29 1.641Zm-23.542 9.199 9.293 9.293L43.311 9.31c.943-.943 2.357.471 1.414 1.414l-20 20c-.328.328-.713.37-1.036.247a1.1 1.1 0 0 1-.447-.276c-.27-.297-.485-.524-.643-.683l-9.288-9.288c-.943-.943.471-2.357 1.414-1.414Z",
    fill: "currentColor"
  }));
};

var SvgChecked = styled(SvgComponent).withConfig({
  displayName: "Checked__SvgChecked",
  componentId: "sc-q3i7j1-0"
})(["", " ", ""], size, color);
export default SvgChecked;